import { render, staticRenderFns } from "./IndexRow.vue?vue&type=template&id=f48d0418&"
import script from "./IndexRow.vue?vue&type=script&lang=js&"
export * from "./IndexRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports